export class InvoiceThird {
  num: number;
  subNum: number;
  type: number;

  constructor(values= {}) {
    Object.assign(this, values);
  }

  /**
   * Returns full third number of this instance
   *
   * @return string
   */
  getFullNumber() {
    const num = this.num ? this.num : '';
    const subNum = this.subNum ? this.subNum : '';
    return `${num}${subNum}`;
  }
}
